/*
The one switch that turns the /api landing page on.

Today `optimiciti.com/api` is a redirect straight out of the site to the docs
portal. That is fine while there is nothing to sell — but it means we have no
page of our own for "route optimization API", the term sitting next to the ones
the ad campaigns already pay for, and `public/robots.txt` disallows the path on
top of that.

The landing page is built and reviewable now; it just isn't reachable. Copy that
depends on the pricing decision is marked in the component, and until it is
settled a live page would either quote numbers we haven't agreed or show gaps.

Flipping this to `true` is step 5 of the launch sequence and does four things at
once, which is the point of having one flag rather than four edits:

  - routes the page (src/index.js and src/routes.js) instead of redirecting;
  - gives it a title/description (src/utils/routeMeta.js), which also makes
    scripts/generate-route-html.js emit a real prerendered /api/index.html for
    link scrapers;
  - puts it in the sitemap (scripts/generate-sitemap.js).

The fourth is NOT automatic and must not be forgotten: remove `Disallow: /api`
from public/robots.txt in the same release. A page in the sitemap and disallowed
in robots.txt is worse than either alone — Search Console reports it as an error
and the URL stays out of the index.

CommonJS so the Node build scripts can require it without a transpile step, the
same reason routeMeta.js is written that way.
*/

const API_LANDING_ENABLED = false;

module.exports = { API_LANDING_ENABLED };
